import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { logger } from '../../../common/utils/logger';

export const onBookmarkAddFailed: (isUpdateModal: boolean) => AnalyticsEventPayload = (
	isUpdateModal: boolean,
): AnalyticsEventPayload => {
	try {
		return {
			action: 'failed',
			actionSubject: isUpdateModal ? 'aiSearchBookmarkUpdate' : 'aiSearchBookmarkAddDismiss',
			eventType: 'track',
		};
	} catch (error) {
		logger.error({ error, functionName: 'onBookmarkAddFailed' });
		return {};
	}
};
